module.exports = __webpack_public_path__ + "img/physical-science.afc555f5.svg";